/**
 * OCHAT: resolves the date-fns locale for relative timestamps ("hace 2 años").
 *
 * Ochat used to hardcode `locale: es` in shared/helpers/timeHelper.js. Two
 * problems with that: it made relative times Spanish for everyone, including the
 * English UI that Ochat also offers, and it broke upstream's timeHelper spec,
 * which asserts "about 2 years ago".
 *
 * timeHelper.js is a plain function module with no access to the store or to
 * component setup, so it cannot read the active locale on its own. The dashboard
 * entrypoint registers the vue-i18n instance here once, and the helper asks this
 * module. Returning undefined is meaningful: date-fns then falls back to en-US,
 * which is what unit tests (and any bundle that never registers) should see.
 */
import { es } from 'date-fns/locale';

// en-US is date-fns' built-in default, so it needs no entry.
const DATE_FNS_LOCALES = { es };

// Empty string until an entrypoint registers: date-fns then falls back to en-US.
let readUiLocale = () => '';

/**
 * Wires the active UI locale in. Call once, from the entrypoint that owns i18n.
 * @param {object} i18n vue-i18n instance
 */
export const registerUiLocaleSource = i18n => {
  readUiLocale = () => {
    const locale = i18n.global?.locale;
    // legacy: false exposes locale as a ref
    return String(locale?.value ?? locale ?? '');
  };
};

/**
 * @returns {object|undefined} the date-fns locale, or undefined for en-US
 */
export const dateFnsLocale = () => {
  // 'pt_BR' and friends: match on the language part only.
  const language = readUiLocale().split(/[-_]/)[0];
  return DATE_FNS_LOCALES[language];
};

export default dateFnsLocale;
